module.exports = __webpack_public_path__ + "img/prizeBg.ea1782be.png";